import axios, { AxiosError } from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const apiService = axios.create({
  baseURL: API_BASE_URL,
});


export const SettingApiData = async () => {
  try {
    const response = await apiService.get("/settings-data");
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const subscribeApi = async (payload: any) => {
  try {
    const respones = await apiService.post("/subscribe", payload);
    return respones.data;
  } catch (error) {}
};

export const addReviewApi = async (token: any, payload: any) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const respones = await apiService.post("/post-review", payload, config);
    return respones.data;
  } catch (error) {
    return error;
  }
};
export const getReviewApi = async (token: any) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const respones = await apiService.get("/get-user-reviews", config);
    return respones.data;
  } catch (error) {
    return error;
  }
};
export const getReviews = async (id: any) => {
  try {
    const response = await apiService.get(`get-customer-reviews/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getCountryList = async () => {
  try {
    const response = await apiService.get("/get-countries");
    return response.data;
  } catch (error) {}
};
export const getStateList = async (countryId: any) => {
  try {
    const response = await apiService.get(`/get-states/${countryId}`);
    return response.data;
  } catch (error) {}
};
export const getCityList = async (stateId: any) => {
  try {
    const respones = await apiService.get(`/get-cities/${stateId}`);
    return respones.data;
  } catch (error) {}
};
export const pageListData = async (pageId: number) => {
  try {
    const response = await apiService.get(`/get-page-data/${pageId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getTopReviews = async () => {
  try {
    const response = await apiService.get(`top-reviews`);
    return response.data;
  } catch (error) {
    throw error;
  }
};